import { Handlers } from "src/shared/VibesListener";
import { addToVibesState } from "src/host/VibesState";
import { Events, EventService } from "src/shared/EventService";
import { getCsrfToken } from "src/shared/getMetaData";

/**
 * This class is responsible for creating the event handlers
 * for parent messages to the iframe
 */
export default class VibesHostEvents {
    private readonly modal: HTMLElement;
    private readonly title: HTMLElement;

    constructor(modal: HTMLElement, title: HTMLElement) {
        this.modal = modal;
        this.title = title;
    }

    handlers(): Handlers {
        return {
            'vibes-open': (...args: string[]) => {
                // update the title to a received translated value
                if (args[0]) {
                    this.title.innerText = args[0];
                }

                this.modal.classList.add('vibes-modal-visible');
                addToVibesState("targeting", true);

                setTimeout(() => {
                    const modal = document.getElementById('vibes-modal-window');
                    if (modal) {
                        const rect = modal.getBoundingClientRect();
                        if (rect.y && rect.y < 0) {
                            // todo: clean up Event Service so we're not constructing more than one
                            const service = new EventService(process.env.API_HOST!, getCsrfToken(window.document));
                            service.saveEvent(Events.formOffScreen, 'NO_WORKFLOW').catch((e) => {
                                if (window.ueLogError) {
                                    window.ueLogError(e, {
                                        logLevel: 'ERROR',
                                        attribution: 'Vibes',
                                        message: 'Unexpected error saving form display event'
                                    });
                                }
                            });
                        }
                    }
                }, 0);
            },
            'vibes-close': () => {
                this.modal.classList.remove('vibes-modal-visible');
            },
            'vibes-refused-targeting': () => {
                addToVibesState("targeting", false);
            },
            default: () => {
                // Do Nothing
            }
        };
    }
}
